var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$route.name === 'MusicCategory')?_c('fragment',[_c('card',{attrs:{"title":"音乐类别"}},[_c('music-category-lite')],1)],1):_vm._e(),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }